import { createReducer } from 'utils/helpers';
import { VehicleActionTypes, IActions } from './VehicleSearch.actions';
import { ICatalogueTypeItem } from './VehicleSearch.properties';

export interface IState {
  VehicleId: number;
  CatalogueTypeId: number;
  CatalogueTypes: ICatalogueTypeItem[];
  SelectedCatalogueEntry: any;
  Searched: any;
}

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<VehicleActionTypes, IAction>;

const actionMap = {
  [VehicleActionTypes.setVehicleId]: (state, payload) => ({ ...state, VehicleId: payload }),
  [VehicleActionTypes.setCatalogueTypeId]: (state, payload) => ({ ...state, CatalogueTypeId: payload }),
  [VehicleActionTypes.setCatalogueTypes]: (state, payload) => ({ ...state, CatalogueTypes: payload }),
  [VehicleActionTypes.setSelectedCatalogueEntry]: (state, payload) => ({ ...state, SelectedCatalogueEntry: payload }),
  [VehicleActionTypes.setSearched]: (state, payload) => ({ ...state, Searched: payload }),
};

export const initialState: IState = {
  VehicleId: -1,
  CatalogueTypeId: -1,
  CatalogueTypes: [],
  SelectedCatalogueEntry: null,
  Searched: {},
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
